/**
 * Dashboard statistics card component
 */

import './StatsCard.css';

/**
 * Card displaying a single statistic
 * @param {Object} props - Component props
 * @param {string} props.title - Card title
 * @param {string|number} props.value - Main value to display
 * @param {string|number} props.totalValue - Optional total shown inline next to value as "(x)"
 * @param {string} props.subtitle - Optional subtitle
 * @param {string|number} props.secondaryValue - Optional secondary value shown below main value
 * @param {string} props.secondaryLabel - Label for the secondary value
 * @param {React.ReactNode} props.icon - Optional icon
 * @param {Array} props.breakdown - Optional breakdown items
 * @returns {React.ReactElement} Card element
 */
export default function StatsCard({
  title,
  value,
  totalValue,
  subtitle,
  secondaryValue,
  secondaryLabel,
  icon,
  breakdown = []
}) {
  return (
    <div className="stats-card">
      <div className="stats-card__header">
        {icon && <div className="stats-card__icon">{icon}</div>}
        <div className="stats-card__title">{title}</div>
      </div>

      <div className="stats-card__value">
        {value}
        {totalValue != null && (
          <span className="stats-card__value-total">({totalValue})</span>
        )}
      </div>

      {subtitle && (
        <div className="stats-card__subtitle">{subtitle}</div>
      )}

      {secondaryValue != null && (
        <div className="stats-card__secondary">
          <span className="stats-card__secondary-value">{secondaryValue}</span>
          {secondaryLabel && (
            <span className="stats-card__secondary-label">{secondaryLabel}</span>
          )}
        </div>
      )}

      {breakdown.length > 0 && (
        <div className="stats-card__breakdown">
          {breakdown.map((item, index) => (
            <div key={index} className="stats-card__breakdown-item">
              <span className="stats-card__breakdown-label">{item.label}</span>
              <span className="stats-card__breakdown-value">{item.value}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
